<template>
    <tbody :id="'tbody_' + items[0].outletID">
        <tr class="dtrg-group dtrg-start dtrg-level-0">
            <td colspan="10" class="text-capitalize">
                <div class="row">
                    <div class="col-sm-12 col-md-9">
                        <span class="text-secondary mr-2"><i class="fas fa-store"></i></span>{{outlet}}
                    </div>
                    <div class="col-sm-12 col-md-3 fs-xs fw-300 text-right">
                        <a class="btn btn-xs btn-outline-primary text-primary outletExpand" @click="showAllDetails(items[0].outletID, null)">{{isExpand == 'Expand' ? $t('button_link.expand_details') : $t('button_link.collapse_details')}}</a>
                    </div>
                </div>
            </td>
        </tr>
        <tr v-for="(item, i) in categoryItems" :key="i">
             <td class="align-middle text-center pt-2">{{i+1}}</td>
             <td class="pt-2">
                <a class="link text-primary fw-700" :id="item.staffID == 'noStaff' ? 'categoryItem_' + item.items[0].outletID + '_' + item.staffID :'categoryItem_' + item.staffID" @click="showDetails($event, item.items[0].outletID)">
                    <i class="fas mr-2" :class="item.staffID == 'noStaff' ? ['fa-user-alt-slash'] : ['fa-user']"></i>
                    {{item.staffID == 'noStaff' ? $t('label.no', {'item': $t('table.header.staff')}) : item.items[0].staffName}}
                </a>
                <div class="border-top border-top-2 mt-1 hide">
                    <div v-for="(type, k) in typeItems" :key="k" :class="{'border-bottom': k+1 != typeItems.length}" class="d-flex align-items-center p-1 text-capitalize">{{type.title}} {{getCategoryText(type.id, item.items[0].item.category)}}</div>
                </div>
            </td>
             <td v-if="selectedPaymentFilter === 'all' || selectedPaymentFilter === ''" class="pt-2 text-center">
                <div class="fw-500 text-dark">
                    {{getTotal(
                        item.effortItems.service.sales, 
                        item.effortItems.product.sales, 
                        item.effortItems.package.sales, 
                        item.effortItems.outstandings.sales
                    )}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.service.sales).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.product.sales).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.package.sales).toFixed(2)}}</div>
                    <div class="text-center p-1" >{{parseFloat(item.effortItems.outstandings.sales).toFixed(2)}}</div>
                </div>
            </td>
            <td v-if="selectedPaymentFilter === 'all' || selectedPaymentFilter === ''" class="border-right-3 pt-2 text-center">
                <div class="fw-500 text-dark">
                    {{getTotal(
                        item.effortItems.service.salesEffort, 
                        item.effortItems.product.salesEffort, 
                        item.effortItems.package.salesEffort, 
                        item.effortItems.outstandings.salesEffort
                    )}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.service.salesEffort).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.product.salesEffort).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.package.salesEffort).toFixed(2)}}</div>
                    <div class="text-center p-1" >{{parseFloat(item.effortItems.outstandings.salesEffort).toFixed(2)}}</div>
                </div>
            </td>
            <td v-if="selectedPaymentFilter === 'all' || selectedPaymentFilter === 'credits'" class="pt-2 text-center">
                <div class="fw-500 text-dark">
                    {{getTotal(
                        item.effortItems.service.credits, 
                        item.effortItems.product.credits, 
                        item.effortItems.package.credits,
                        item.effortItems.outstandings.credits
                    )}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.service.credits).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.product.credits).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.package.credits).toFixed(2)}}</div>
                    <div class="text-center p-1" >{{parseFloat(item.effortItems.outstandings.credits).toFixed(2)}}</div>
                </div>
            </td>
            <td v-if="selectedPaymentFilter === 'all' || selectedPaymentFilter === 'credits'" class="border-right-3 pt-2 text-center">
                <div class="fw-500 text-dark">
                    {{getTotal(
                        item.effortItems.service.creditEffort, 
                        item.effortItems.product.creditEffort, 
                        item.effortItems.package.creditEffort, 
                        item.effortItems.outstandings.creditEffort
                    )}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.service.creditEffort).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.product.creditEffort).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.package.creditEffort).toFixed(2)}}</div>
                    <div class="text-center p-1" >{{parseFloat(item.effortItems.outstandings.creditEffort).toFixed(2)}}</div>
                </div>
            </td>
            <td v-if="selectedPaymentFilter === 'all' || selectedPaymentFilter === 'package'" class="pt-2 text-center">
                <div class="fw-500 text-dark">
                    {{getTotal(
                        item.effortItems.service.packages, 
                        item.effortItems.product.packages, 
                        item.effortItems.package.packages, 
                        item.effortItems.outstandings.packages
                    )}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.service.packages).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.product.packages).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.package.packages).toFixed(2)}}</div>
                    <div class="text-center p-1" >{{parseFloat(item.effortItems.outstandings.packages).toFixed(2)}}</div>
                </div>
            </td>
            <td v-if="selectedPaymentFilter === 'all' || selectedPaymentFilter === 'package'" class="border-right-3 pt-2 text-center">
                <div class="fw-500 text-dark">
                    {{getTotal(
                        item.effortItems.service.packageEffort, 
                        item.effortItems.product.packageEffort, 
                        item.effortItems.package.packageEffort,  
                        item.effortItems.outstandings.packageEffort
                    )}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.service.packageEffort).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.product.packageEffort).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.package.packageEffort).toFixed(2)}}</div>
                    <div class="text-center p-1" >{{parseFloat(item.effortItems.outstandings.packageEffort).toFixed(2)}}</div>
                </div>
            </td>
            <td v-if="selectedPaymentFilter === 'all'" class="pt-2 text-center">
                <div class="fw-900 text-dark">
                    {{parseFloat(item.totalEffort).toFixed(2)}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{getEffort(item.effortItems.service.salesEffort, item.effortItems.service.creditEffort, item.effortItems.service.packageEffort)}}</div>
                    <div class="border-bottom text-center p-1" >{{getEffort(item.effortItems.product.salesEffort, item.effortItems.product.creditEffort, item.effortItems.product.packageEffort)}}</div>
                    <div class="border-bottom text-center p-1" >{{getEffort(item.effortItems.package.salesEffort, item.effortItems.package.creditEffort, item.effortItems.package.packageEffort)}}</div>
                    <div class="text-center p-1" >{{getEffort(item.effortItems.outstandings.salesEffort, item.effortItems.outstandings.creditEffort, item.effortItems.outstandings.packageEffort)}}</div>
                </div>
            </td>
            <td class="pt-2 text-center">
                <div class="fw-900 text-dark">
                    {{parseFloat(item.totalFee).toFixed(2)}}
                </div>
                <div class="border-top border-top-2 mt-1 hide">
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.service.fee).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.product.fee).toFixed(2)}}</div>
                    <div class="border-bottom text-center p-1" >{{parseFloat(item.effortItems.package.fee).toFixed(2)}}</div>
                    <div class="text-center p-1" >{{parseFloat(item.effortItems.outstandings.fee).toFixed(2)}}</div>
                </div>
            </td>
        </tr>
    </tbody>
</template>
<script>
import _ from 'lodash';
import cst, {calculateCategoryTotalRedeem} from './../../../../assets/js/dashboard/salonReport/salonReport'

export default {
    name:'commissionCategoryTable',
    props:{ 
        items: { type: Array },
        outlet: { type: String },
        staffObj: { type: Object },
        selectedCategory: { type: Number },
        selectedPaymentFilter: { type: String, default: 'all' },
    },
    data(){
        return{
            isExpand: "Expand", 
            categoryItems: []
        }
    },
    computed:{
        typeItems(){
            let spy = cst.commissionReportItemType
            for(var i=0; i<spy.length; i++){
                spy[i].title = this.$i18n.t('salon_report.item_types.'+ spy[i].id)
            }
            return spy
        },
        groupItems(){
            let group = this.items.reduce((result, item) => {
            var staffs = item.staffs;
            if(staffs.length != 0){
                for(var i=0; i<staffs.length; i++){
                    if(this.staffObj.staffID == ""){ //all staff 
                        if(!(staffs[i].staffID in result)){ 
                            var newItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
                            newItem['staffName'] = staffs[i].name
                            result[staffs[i].staffID] =[newItem]
                        }else{
                            if (result[staffs[i].staffID].filter(e => e.completedID == item.completedID).length == 0) {
                                var _newItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
                                _newItem['staffName'] = staffs[i].name
                                result[staffs[i].staffID] =[...result[staffs[i].staffID],_newItem]
                            }
                        }
                    }else{
                        if(staffs[i].staffID == this.staffObj.staffID){
                            if(!(staffs[i].staffID in result)){ 
                                var nItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
                                nItem['staffName'] = staffs[i].name
                                result[staffs[i].staffID] =[nItem]
                            }else{
                                if (result[staffs[i].staffID].filter(el => el.completedID == item.completedID).length == 0) {
                                    var _ntem = Object.assign({}, JSON.parse(JSON.stringify(item)))
                                    _ntem['staffName'] = staffs[i].name
                                    result[staffs[i].staffID] =[...result[staffs[i].staffID],_ntem]
                                }
                            }
                        }
                    }
                }
            }else{
                result['noStaff'] = [...result['noStaff'] ||[], item]
            }
            return result;
            }, {});

            return group
        },
        objItems(){
            var arr = []
            for(var g in this.groupItems){
                var obj = this.handleGroupItems(this.groupItems[g], g)
                arr.push(obj)
            }
            return arr
        },
    },
    watch:{
        groupItems(value){
            this.setTotalEntries(Object.keys(value).length)
            this.setCategoryItems(value)
        },
    },
    methods:{
        formatPrice(p){
            return parseFloat(p).toFixed(2);
        },
        getCategoryText(type, category){
            var categoryText = ""
            if(this.selectedCategory == -1){
                categoryText = ""
            }else{
                if(type == "outstandings"){
                    categoryText = "( - )"
                }else{
                    var categoryList = JSON.parse(this.$store.state.category)
                    for(var key in categoryList){
                        if(key == type){
                            categoryText = "(" + categoryList[key][category] + ")"
                            break;
                        }
                    }
                } 
            }
            return categoryText
        },
        showDetails(e, outletID){
            var link = e.target.id;
            var tr = document.getElementById(link).parentElement.parentElement;
            var detailsContainer = tr.getElementsByClassName('border-top');

            for(var i=0; i<detailsContainer.length; i++){
                detailsContainer[i].classList.contains('hide') ? detailsContainer[i].classList.remove('hide') : detailsContainer[i].classList.add('hide')
            }

            var hideCount = 0;
            var allRow = document.getElementById("tbody_" + outletID).querySelectorAll("tr");
            for(var j=1; j<allRow.length; j++){
                var hiddenRow = allRow[j].getElementsByClassName('hide');
                if(hiddenRow.length != 0){
                    hideCount++;
                }
                
            }
            if(hideCount == Object.keys(this.groupItems).length){
                if(this.isExpand == "Collapse"){
                    this.isExpand = "Expand"
                }
            }else{
                this.isExpand = "Collapse"
            }
            this.$emit('setExpandAll', this.isExpand)
        },
        showAllDetails(outletID, isExpandAll){
            var isExpand = false;
            if(this.isExpand == "Expand"){
                isExpand = true;
                this.isExpand = "Collapse"
            }else{
                isExpand = false;
                this.isExpand = "Expand"
            }
            
            var detailsContainer = document.getElementById("tbody_" + outletID).querySelectorAll(".border-top");
            
            for(var i=0; i<detailsContainer.length; i++){
                if(isExpandAll != null){
                    if(isExpandAll){
                        if(detailsContainer[i].classList.contains('hide')){
                            detailsContainer[i].classList.remove('hide')
                        }
                        this.isExpand = "Collapse";
                    }else{
                        if(!detailsContainer[i].classList.contains('hide')){
                            detailsContainer[i].classList.add('hide')
                        }
                        this.isExpand = "Expand";
                    }
                }else{
                    if(isExpand){
                        if(detailsContainer[i].classList.contains('hide')){
                            detailsContainer[i].classList.remove('hide')
                        }
                    }else{
                        if(!detailsContainer[i].classList.contains('hide')){
                            detailsContainer[i].classList.add('hide')
                        }
                    }
                }
            }
            this.$emit('setExpandAll', this.isExpand)
        },
        handleGroupItems(item, id){
            var group = _.groupBy(item, 'item.type')
            var items = {
                service: "service" in group ? group["service"] : [],
                product: "product" in group ? group["product"] : [],
                package: "package" in group ? group["package"] : [],
                outstandings: "outstandings" in group ? group["outstandings"] : [],
            }
            for(var i in items){
                items[i] = this.getSum(items[i], id)
            }
            return items
        },
        getSum(item, id){
            var items = {
                sales: 0, salesEffort: 0, salesFee: 0, salesQty: 0,
                credits: 0, creditEffort: 0, creditFee: 0, creditsQty: 0,
                packages: 0, packageEffort: 0, packageFee: 0, packagesQty: 0,
                fee: 0
            }; 
            for(var i=0; i<item.length; i++){
                items = calculateCategoryTotalRedeem(id, item[i].redeem, item[i].price, item[i].discount, item[i].outstandings, item[i].staffs, items)
            }
            return items;
        },
        getEffort(sales, credits, packages){
            var effort = sales + credits + packages
            return this.formatPrice(effort)
        },
        getTotal(sales, product, pkg, outstandings){
            return this.formatPrice(sales + product + pkg + outstandings)
        },
        setTotalEntries(len){
            this.$emit('setTotalEntries', len);
        },
        setCategoryItems(value){
            this.categoryItems = []
            var i = 0
            for(var k in value){
                this.categoryItems.push({
                    staffID: k,
                    items: value[k],
                    effortItems: this.objItems[i],
                    totalEffort: parseFloat(this.getEffort(
                        this.objItems[i].service.salesEffort + this.objItems[i].product.salesEffort + this.objItems[i].package.salesEffort +  this.objItems[i].outstandings.salesEffort,
                        this.objItems[i].service.creditEffort + this.objItems[i].product.creditEffort + this.objItems[i].package.creditEffort + this.objItems[i].outstandings.creditEffort,
                        this.objItems[i].service.packageEffort + this.objItems[i].product.packageEffort + this.objItems[i].package.packageEffort + this.objItems[i].outstandings.packageEffort
                    )),
                    totalFee: parseFloat(this.getTotal(
                        this.objItems[i].service.fee, 
                        this.objItems[i].product.fee, 
                        this.objItems[i].package.fee, 
                        this.objItems[i].outstandings.fee
                    ))
                })
                i++
            }
            
            this.categoryItems = _.orderBy(this.categoryItems, ['totalEffort'], ['desc'])
        }
    },
    mounted(){
        let $vm = this;
        $vm.setTotalEntries(Object.keys($vm.groupItems).length)
        $vm.setCategoryItems($vm.groupItems)
    },
}
</script>
<style scoped>
.hide{
    display: none;
}
.border-top-2{
    border-top-width:  2px !important;
}
.border-right-3{
    border-right-width: 3px;
}
.link{
    cursor: pointer;
}
.card-table tr:nth-of-type(odd)>td:first-child{
    background: #ccbfdf;
    color: #fff;
}
.card-table tr>td:first-child{
    font-weight: 400;
}
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}
</style>